<template>
  <b-container fluid>
    <main-modal id="instructorDetalilsModal" size="lg">
      <template v-slot:header>
        <h4 class="font-weight-bold">Instructor Information</h4>
      </template>
      <template v-slot:body>
        <instructor-details :instructor-details="instructorDetails" :requestLoading="requestLoading"
                            @request="acceptOrReject"/>
      </template>
    </main-modal>
    <b-row>
      <b-col lg="12" class="mb-2">
        <h3>Instructors</h3>
      </b-col>
      <b-col lg="12" class="mb-2">
        <iq-card class="filter-card">
          <b-row>
            <b-col md="3">
              <span>Filter by name:</span>
              <b-form-input v-model="filter.name" @keyup="reloadTable=true"
                            placeholder="Search">
              </b-form-input>
            </b-col>
            <b-col md="3">
              <span>Filter by status:</span>
              <main-select v-model="filter.status" @change="reloadTable=true"
                           :options="statusFilterOptions"
                           label="key"
                           :reduce="data => data.value"
                           placeholder="--Select--">
              </main-select>
            </b-col>
          </b-row>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <main-table
            :fields="columns"
            class="mb-0 table-borderless"
            @sortChanged="sortChanged"
            :list_url="'instructors'"
            :reloadData="reloadTable"
            :custom-filter="filter"
        >
        </main-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import instructorDetails from '../components/instructorDetails.vue'
import instructorsServices from '../services/instructors.services'

export default {
  components: { instructorDetails: instructorDetails },
  data () {
    return {
      columns: [
        '#',
        {
          label: 'Name',
          key: 'full_name',
          class: 'text-left'
        },
        {
          label: 'Business',
          key: 'center_name',
          class: 'text-left'
        },
        {
          label: 'Phone Number',
          key: 'phone',
          class: 'text-left'
        },
        // { label: 'Email', key: 'email', class: 'text-left' },
        {
          label: 'Business',
          key: 'center_name',
          class: 'text-left'
        },
        {
          label: 'Status',
          key: 'status',
          class: 'text-left',
          type: 'status'
        },
        {
          label: 'Actions',
          key: 'actions',
          class: 'text-left',
          type: 'actions',
          actions: [{
            icon: 'las la-eye',
            color: 'success-light',
            text: 'View',
            actionName: 'viewinstructor',
            showIf: () => this.hasPer('lead.view'),
            actionParams: 'fullObj'
          },
            {
              icon: 'las la-trash-alt',
              color: 'danger',
              text: 'Delete',
              showAlert: true,
              actionHeader: 'Delete',
              titleHeader: 'instructors',
              url: 'instructors',
              textContent: 'full_name'
            }
          ]
        }
      ],
      instructorDetails: {},
      requestLoading: false,
      selectedinstructor: '',
      reloadTable: false,
      filter: {
        profile_completed: true,
        name: '',
        status: ''
      },
      statusFilterOptions: [
        {
          key: 'New',
          value: 'new'
        },
        {
          key: 'Accepted',
          value: 'accepted'
        },
        {
          key: 'Rejected',
          value: 'rejected'
        },
        {
          key: 'None',
          value: ''
        }
      ]
    }
  },
  methods: {
    sortChanged (key) {
      this.reloadTable = false
      this.filter.sort_type = key.sortDesc ? 'desc' : 'asc'
      this.reloadTable = true
    },
    viewinstructor (obj) {
      this.selectedinstructor = obj.id
      this.instructorDetails = obj
      this.$bvModal.show('instructorDetalilsModal')
    },
    acceptOrReject (data) {
      this.requestLoading = true
      this.reloadTable = false
      instructorsServices.updateinstructor(this.selectedinstructor, data).then(res => {
        core.showSnackbar('success', res.data.message)
        this.reloadTable = true
        this.$bvModal.hide('instructorDetalilsModal')
      }).finally(() => {
        this.requestLoading = false
      })
    }
  },
  mounted () {
    core.index()
  },
  beforeDestroy () {
    this.$root.$off('viewinstructor', this.viewinstructor)
  },
  created () {
    this.$root.$on('viewinstructor', this.viewinstructor)
  }
}
</script>
